import React from 'react';
import styled from 'styled-components';
import ControlPlaneLayout from './ControlPlaneLayout';

const PolicyGrid = styled.div`
  display: grid;
  gap: 1rem;
  margin-top: 1rem;

  @media (min-width: 960px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

const PolicyCard = styled.section`
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 24px;
  padding: 1.25rem;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);
`;

const PolicyTitle = styled.h2`
  margin: 0 0 0.75rem;
  font-size: 1.1rem;
  color: #0f172a;
`;

const PolicyBody = styled.p`
  margin: 0;
  color: #475569;
  line-height: 1.7;
`;

const PolicyList = styled.ul`
  margin: 1rem 0 0;
  padding-left: 1.1rem;
  color: #0f172a;
  line-height: 1.8;
`;

const policies = [
  {
    title: 'Small-cash pilot',
    body:
      'Real-money release stays capped and manual so benchmark-cleared portfolio runs can be paid without turning the request rail into an unattended payout engine.',
    items: [
      '$25.00 per approved request',
      'Manual approval required',
      'Benchmark proof bundle required before release review',
    ],
  },
  {
    title: 'Live benchmark discipline',
    body:
      'Only pre-approved providers and variants can cross from benchmark mode into live execution, and they stay pinned to the same cadence used in HedgeBench review.',
    items: [
      'Gemini 2.5 Pro, Gemini 3 Pro Preview',
      'with_news only',
      'Open and close session cadence',
    ],
  },
  {
    title: 'Settlement guardrails',
    body:
      'Cash pilot releases stay tied to broker evidence, reconciliation, and explicit operator signoff so the discipline system remains reliable under production conditions.',
    items: [
      'IBKR reconciliation',
      'Latest benchmark PnL must clear the live baseline',
      'No automatic cash release while the pilot is active',
    ],
  },
];

const PoliciesPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Policy controls"
      title="Policy controls"
      description="Manage the live benchmark discipline, capped cash pilot, and operator settlement guardrails used for production request runs."
    >
      <PolicyGrid>
        {policies.map(policy => (
          <PolicyCard key={policy.title}>
            <PolicyTitle>{policy.title}</PolicyTitle>
            <PolicyBody>{policy.body}</PolicyBody>
            <PolicyList>
              {policy.items.map(item => (
                <li key={item}>{item}</li>
              ))}
            </PolicyList>
          </PolicyCard>
        ))}
      </PolicyGrid>
    </ControlPlaneLayout>
  );
};

export default PoliciesPage;
